import styled from 'styled-components'
import { theme } from '@provi/provi-components'

export const PageContainer = styled.div`
  min-height: 100vh;
  padding: 40px 0;

  ${theme.breakpoints.down('md')} {
    padding: 24px 0;
  }
`

export const PageGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 352px;
  gap: 48px;
  align-items: start;
  justify-content: center;

  ${theme.breakpoints.down('md')} {
    grid-template-columns: 1fr;
    gap: 32px;
  }
`

export const PaymentCard = styled.div`
  background: white;
  border-radius: 16px;
  padding: 0 0 40px 0;
  overflow: hidden;
  max-width: 770px;

  ${theme.breakpoints.down('md')} {
    padding: 0 0 32px 0;
    max-width: 100%;
  }
`

export const HeaderBadge = styled.div`
  background: #083cbc;
  height: 64px;
  padding: 0 40px;
  margin-bottom: 40px;
  display: flex;
  align-items: center;
  gap: 10px;
  color: white;

  ${theme.breakpoints.down('md')} {
    padding: 0 24px;
    margin-bottom: 32px;
  }
`

/** Header badge verde para estado "Pagamento confirmado" */
export const HeaderBadgeSuccess = styled(HeaderBadge)`
  background: #2e7d32;
`

export const HeaderIcon = styled.div`
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const HeaderText = styled.span`
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  font-weight: 500;
  line-height: 28px;
  letter-spacing: 0;
  text-transform: uppercase;
`

export const ContentWrapper = styled.div`
  padding: 0 40px;
  display: flex;
  flex-direction: column;
  gap: 32px;

  ${theme.breakpoints.down('md')} {
    padding: 0 24px;
  }
`

export const SectionTitle = styled.h1`
  font-family: 'Inter', sans-serif;
  font-size: 24px;
  font-weight: 600;
  line-height: 24px;
  color: #262626;
  margin: 0 0 8px 0;
`

export const SectionSubtitle = styled.p`
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  color: #666666;
  margin: 0;
`

export const PaymentSuccessMessage = styled.p`
  font-family: 'Inter', sans-serif;
  font-size: 18px;
  font-weight: 600;
  line-height: 28px;
  color: #0f7b42;
  margin: 0;
  padding: 24px 0;
`

/** Banner de sucesso - usado quando fatura está paga */
export const PaidSuccessBanner = styled.div`
  background: #cceeff;
  border-radius: 6px;
  padding: 12px 16px;
  display: flex;
  gap: 12px;
  min-height: 56px;
  align-items: center;
`

/** Ícone do banner de sucesso: apenas o fundo azul; o ícone "!" fica em branco */
export const PaidSuccessIconWrapper = styled.div`
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  background: #1976d2;
  border-radius: 4px;
`

/** Texto do banner de sucesso: preto, fundo azul claro */
export const PaidSuccessBannerText = styled.span`
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  color: #000000;
  background: #cceeff;
  padding: 4px 8px;
  border-radius: 4px;
`

/** Wrapper para centralizar o botão no final do ContentWrapper (estado pago) */
export const SuccessButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  margin-top: 24px;
`

export const WarningBanner = styled.div`
  background: #fce4cf;
  border-radius: 6px;
  padding: 12px 16px;
  display: flex;
  gap: 12px;
  min-height: 56px;
  align-items: center;
`

export const WarningIconWrapper = styled.div`
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`

export const WarningContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const WarningTitle = styled.span`
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  color: #262626;
`

export const WarningText = styled.span`
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  color: #262626;
`

export const PixSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 8px;
`

export const PixLabel = styled.span`
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  color: #999999;
`

export const PixQRCode = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 202px;
    height: 202px;
    object-fit: cover;
  }
`

export const PixCopyButton = styled.button`
  border: 1px solid #0273ff;
  color: #0273ff;
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  border-radius: 6px;
  padding: 8px 16px;
  height: 40px;
  background: transparent;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  transition: background 0.2s ease, color 0.2s ease;

  svg {
    width: 20px;
    height: 20px;
  }

  &:hover {
    background: #0273ff;
    color: white;

    svg path {
      fill: white;
    }
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`

export const EntryCard = styled.div`
  border: 1px solid #e6e6e6;
  border-radius: 8px;
  padding: 16px;
  background: #fff;
`

export const EntryRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 8px;

  &:last-child {
    margin-bottom: 0;
  }
`

export const EntryLabel = styled.span`
  font-family: 'Inter', sans-serif;
  font-size: 18px;
  font-weight: 700;
  line-height: 28px;
  color: #262626;
`

export const EntryValue = styled.span`
  font-family: 'Inter', sans-serif;
  font-size: 18px;
  font-weight: 700;
  line-height: 28px;
  color: #262626;
  text-align: right;
`

export const EntrySubLabel = styled.span`
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  color: #999999;
`

export const EntrySubValue = styled.span`
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  color: #ad1f22;
  text-align: right;
`

export const AlternativePayment = styled.div`
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const AlternativeText = styled.span`
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  color: #999999;
`

export const AlternativeActions = styled.div`
  display: flex;
  justify-content: center;
  gap: 16px;

  ${theme.breakpoints.down('sm')} {
    flex-direction: column;
    gap: 12px;
  }
`

export const AlternativeLink = styled.a`
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  color: #0273ff;
  text-decoration: none;
  display: inline-flex;
  gap: 4px;
  align-items: center;
  padding: 8px 16px;
  height: 40px;
  border-radius: 6px;
  transition: background 0.2s ease;

  svg {
    width: 20px;
    height: 20px;
  }

  &:hover {
    background: rgba(2, 115, 255, 0.1);
  }
`
